import portableTextToPlain from '@ahmdigital/logic/lib/content/utils/portable-text-to-plain';

import type { CmsInsuranceTypeContent, StaticInsuranceTypeContent } from '../../types';

const getMetaData = (cmsData: Partial<CmsInsuranceTypeContent>, staticContent: StaticInsuranceTypeContent) => {
  const staticTitle = staticContent?.meta?.title ?? null;
  const staticDescription = staticContent?.meta?.description ?? null;

  const cmsTitle = cmsData?.metadataObject?.title;
  const cmsDescription = portableTextToPlain(cmsData?.metadataObject?.description);

  return {
    description: cmsDescription || staticDescription,
    title: cmsTitle || staticTitle,
  };
};

export default getMetaData;
